module.exports = __webpack_public_path__ + "static/media/053-concierge.8633c2a2.svg";